import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { type Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { grid, dialogPageTakeoverWidth } from '../style-utils';
import type { SearchCSS } from '../theme';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ClearIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
> = styled('div')<SearchCSS>`
	width: ${grid.multiple(2).px};
	height: ${grid.multiple(2).px};
	padding: 5px ${token('space.075')};
	color: ${token('color.text.subtlest')};
	background-color: transparent;

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		display: none;
	}

	:hover {
		cursor: pointer;
		color: ${token('color.icon')};
	}

	& > span > svg {
		vertical-align: unset;
	}
`;
